export const GoogleMapApiConfig = 'AIzaSyCWyJpwiQdOICfupbX-Cqw6Tq9tD2e_tEU';